export const getSubdomain = () => {
  const host = window.location.hostname;
  const parts = host.split(".");
  if (host.includes("localhost") || parts.length <= 2)
    return import.meta.env.VITE_AGENT_SLUG;
  return parts[0];
};
